<template>
  <v-main>
    <stepper-tin
      v-if="quizz && quizz.department === 'TIN'"
      :questions="quizz.questions"
      :filieres="quizz.filieres"
    />
    <stepper-tic
      v-if="quizz && quizz.department === 'TIC'"
      :questions="quizz.questions"
      :filieres="quizz.filieres"
    />
  </v-main>
</template>

<script>
import StepperTin from "@/components/StepperTin.vue";
import StepperTic from "@/components/StepperTic.vue";
import quizzs from "@/data/quizzs.json";

export default {
  name: "Quizzs",
  components: {
    StepperTin,
    StepperTic,
  },
  data: () => ({
    quizz: null,
  }),
  created() {
    const found = quizzs.find(
      (q) => String(q.id) === String(this.$route.params.id)
    );
    // Deep-clone: the steppers mutate filieres/answers in place, so each
    // visit needs a fresh copy or scores leak across navigations.
    this.quizz = found ? JSON.parse(JSON.stringify(found)) : null;
  },
};
</script>